import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Row, Col } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaPlusCircle, FaRegClock, FaUserCheck } from 'react-icons/fa';
import CatPermisos from '../../../Services/Catalogos/CatPermisos';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import { DTOPermiso } from './DTO/DTOPermiso';
import DTOEmpleadoVac from '../../Catalogos/CatEmpleados/DTO/DTOEmpleadoVac';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import { FaClipboardList } from 'react-icons/fa';







const CatPermisosUsuario = () => {
  const [empleado, setEmpleado] = useState<DTOEmpleadoVac | null>(null);
  const [permisos, setPermisos] = useState<DTOPermiso[]>([]);
  const [showModal, setShowModal] = useState(false);

  

  const [nuevoPermiso, setNuevoPermiso] = useState<DTOPermiso>({
    id: 0,
    fechaPermiso: '',
    fechaSolicitud: new Date().toISOString().split('T')[0],
    nombreEmpleado: '',
    puestoEmpleado: '',
    motivo: '',
    horaInicio: '',
    horaFin: '',
    permisoConSueldo: false,
    autorizador: '',
    observaciones: '',
    estado: 'Pendiente',
    fechaAceptacionPermiso: null,
    correo: '', // Asegúrate de que este campo esté presente
    numEmpleado: '', 
    esDiaCompleto: false,
  });

  const [msg, setMsg] = useState('');
  const [header, setHeader] = useState('');
  const [showMsg, setShowMsg] = useState(false);
  const msgColor = 'primary';
    useEffect(() => {
      const interval = setInterval(() => {
        if (empleado?.numEmpleado) {
          cargarPermisos(empleado.numEmpleado);
        }
      }, 10000); 

      return () => clearInterval(interval);
    }, [empleado]);



  const cargarEmpleado = async () => {
    const userIdString = localStorage.getItem("UserId");

    if (!userIdString) {
      console.error("No se encontró UserId en localStorage.");
      return;
    }

    const userId = Number(JSON.parse(userIdString));

    if (isNaN(userId) || userId <= 0) {
      console.error("UserId no es válido:", userIdString);
      return;
    }

    try {
      const response = await CatEmpleados.GetIdEmpleado(userId);

      if (!response.data || response.data.length === 0) {
        console.error("No se encontró información del empleado.");
        return;
      }

      const user = response.data[0];

      setEmpleado(user);

      setNuevoPermiso(prev => ({
        ...prev,
        nombreEmpleado: user.nombreEmpleado,
        puestoEmpleado: user.departamento,
        numEmpleado: user.numEmpleado
      }));

      cargarPermisos(user.numEmpleado);
    } catch (error) {
      console.error("Error al obtener datos del empleado:", error);
    }
  };

  const cargarPermisos = (numEmpleado: string) => {
    CatPermisos.GetPermisosPorEmpleado(numEmpleado)
      .then((res) => setPermisos(res.data))
      .catch((err) => console.error('Error al obtener permisos:', err));
  };

 






const insertarPermiso = () => {
  if (!empleado) return;

  if (!nuevoPermiso.fechaPermiso || !nuevoPermiso.motivo) {
    setMsg('Faltan campos obligatorios como Fecha y Motivo.');
    setHeader('Atención');
    setShowMsg(true);
    return;
  }

  
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  
  // Validación de fecha: No permitir fechas mayores a 1 semana en el pasado
  const fechaPermiso = new Date(nuevoPermiso.fechaPermiso);
  const fechaActual = new Date();
  const unaSemanaAtras = new Date();
  unaSemanaAtras.setDate(fechaActual.getDate() - 7);
  
  // Normalizar fechas (solo día, sin hora)
  fechaPermiso.setHours(0, 0, 0, 0);
  unaSemanaAtras.setHours(0, 0, 0, 0);
  fechaActual.setHours(0, 0, 0, 0);

  if (fechaPermiso < unaSemanaAtras) {
    setHeader('Error de fecha');
    setMsg('Solo se pueden registrar permisos con fecha hasta una semana antes de la fecha actual.');
    setShowMsg(true);
    return;
  }


  // ⏰ Validaciones de horario si no es día completo
  if (!nuevoPermiso.esDiaCompleto) {
    const horaInicio = nuevoPermiso.horaInicio;
    const horaFin = nuevoPermiso.horaFin;

    if (!horaInicio || !horaFin) {
      setMsg('Debes ingresar hora de salida y regreso.');
      setHeader('Horario requerido');
      setShowMsg(true);
      return;
    }

    const horaMinima = '08:00';
    const horaMaxima = '18:00';

    if (horaInicio < horaMinima || horaInicio > horaMaxima) {
      setMsg('La hora de salida debe estar entre 08:00.');
      setHeader('Hora de salida inválida');
      setShowMsg(true);
      return;
    }

    if (horaFin < horaMinima || horaFin > horaMaxima) {
      setMsg('La hora de regreso solo es apicable  antes de 18:00.');
      setHeader('Hora de regreso inválida');
      setShowMsg(true);
      return;
    }

    if (horaFin <= horaInicio) {
      setMsg('La hora de regreso debe ser posterior a la hora de salida.');
      setHeader('Orden de horas inválido');
      setShowMsg(true);
      return;
    }
  }

  // ✅ Si pasa todas las validaciones
  const permisoAInsertar: DTOPermiso = {
    ...nuevoPermiso,
    numEmpleado: empleado.numEmpleado
  };

  CatPermisos.PosInsertarPermiso(permisoAInsertar)
    .then(async () => {
      setShowModal(false);
      setMsg('Permiso registrado correctamente.');
      setHeader('Éxito');
      setShowMsg(true);
      cargarPermisos(empleado.numEmpleado);
      limpiarFormulario();

      const correoSupervisor = localStorage.getItem('correoSupervisor')?.replace(/"/g, '');
      if (nuevoPermiso.estado === 'Pendiente' && correoSupervisor) {
        const notificacion = {
          id: 0,
          numEmpleado: permisoAInsertar.numEmpleado,
          nombreEmpleado: permisoAInsertar.nombreEmpleado,
          correo: correoSupervisor,
          motivo: permisoAInsertar.motivo,
          fechaPermiso: permisoAInsertar.fechaPermiso,
          estado: permisoAInsertar.estado, 
          observaciones: permisoAInsertar.observaciones || ''
        };

        try {
          await CatPermisos.EnviarCorreoPermiso(notificacion);
        } catch (error) {
          console.error('Error al enviar correo:', error);
        }
      }
    })
    .catch((err) => {
      const mensajeError = err?.response?.data?.message || 'Error al insertar permiso.';
      console.error('Error al insertar permiso:', mensajeError);
      setHeader('Error');
      setMsg(mensajeError);
      setShowMsg(true);
    });
};


  const limpiarFormulario = () => {
    setNuevoPermiso(prev => ({
      ...prev,
      fechaPermiso: '',
      motivo: '',
      horaInicio: '',
      horaFin: '',
      permisoConSueldo: false,
      autorizador: '',
      observaciones: '',
      estado: 'Pendiente',
      esDiaCompleto: false
    }));
  };

  useEffect(() => {
    cargarEmpleado();
  }, []);

 



  const generarCredencialPermiso = async (row: DTOPermiso) => {
  const response = await CatEmpleados.GetSuperFirma(row.numEmpleado);
  const numSupervisor = response.data?.numSupervisor || null;
  const numRh = response.data?.numEmpleadoRH || null;
  const numEmpleado = response.data?.numEmpleado || null;

  let firmaEmpleado = '';
  let firmaSupervisor = '';
  let firmaRH = '';

  try {
    if (numEmpleado) {
      const res = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');
      firmaEmpleado = res || '';
    }
    if (numSupervisor) {
      const res = await CatEmpleados.GetFotoFirma(numSupervisor, 'firma');
      firmaSupervisor = res || '';
    }
    if (numRh) {
      const res = await CatEmpleados.GetFotoFirma(numRh, 'firma');
      firmaRH = res || '';
    }
  } catch (e) {
    console.error('Error al obtener firmas:', e);
  }

  const ventana = window.open('', '_blank');
  if (!ventana) {
    alert('Desactiva el bloqueador de ventanas emergentes.');
    return;
  }

ventana.document.write(`
  <html>
  <head>
    <meta charset="UTF-8">
    <title>Credencial de Permiso</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
      body {
        font-family: 'Roboto', sans-serif;
        background-color: #f0f0f0;
        padding: 40px;
      }
      .card {
        width: 650px;
        margin: auto;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
      }
      .header {
        background: linear-gradient(to right, #0052cc, #007fff);
        color: white;
        padding: 30px;
        text-align: center;
        position: relative;
      }
      .header img {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 60px;
      }
      .header h2 {
        margin: 0;
        font-size: 26px;
      }
      .content {
        padding: 30px;
        font-size: 18px;
      }
      .row {
        margin-bottom: 14px;
      }
      .row strong {
        display: inline-block;
        width: 160px;
      }
      .firmas {
        display: flex;
        justify-content: space-around;
        padding: 20px 30px 30px;
      }
      .firma {
        width: 100px;
        height: 60px;
        border: 1px dashed #999;
        padding: 4px;
        text-align: center;
      }
      .firma img {
        max-width: 100%;
        max-height: 100%;
      }
      .footer {
        background-color: #f9f9f9;
        text-align: center;
        padding: 15px;
        font-size: 14px;
        color: #666;
      }
    </style>
  </head>
  <body>
    <div class="card">
      <div class="header">
        <img src="GEMCO.png" alt="Logo" />
        <h2>Credencial de Permiso</h2>
      </div>
      <div class="content">
        <div class="row"><strong>Empleado:</strong> ${row.nombreEmpleado}</div>
        <div class="row"><strong>Puesto:</strong> ${row.puestoEmpleado}</div>
        <div class="row"><strong>Motivo:</strong> ${row.motivo}</div>
        <div class="row"><strong>Fecha:</strong> ${formatearFecha(row.fechaPermiso)}</div>
        <div class="row"><strong>Horario:</strong> ${row.esDiaCompleto ? 'Día Completo' : `${row.horaInicio} - ${row.horaFin}`}</div>
        <div class="row"><strong>Estado:</strong> ${row.estado}</div>
       
      </div>
      <div class="firmas">
        <div class="firma"><img src="${firmaEmpleado}" alt="Firma Empleado" /></div>
        <div class="firma"><img src="${firmaSupervisor}" alt="Firma Supervisor" /></div>
        <div class="firma"><img src="${firmaRH}" alt="Firma RH" /></div>
      </div>
      <div class="footer">
        GEMCO | Nuevo Laredo, Tamps. <br />
        www.gemcousa.com
      </div>
    </div>
    <script>setTimeout(() => { window.print(); window.close(); }, 600);</script>
  </body>
  </html>
`);

  ventana.document.close();
};


const formatearFecha = (fecha: string) => {
  if (!fecha) return '';
  const date = new Date(fecha);
  const dia = date.getDate().toString().padStart(2, '0');
  const mes = (date.getMonth() + 1).toString().padStart(2, '0');
  const anio = date.getFullYear();
  return `${dia}/${mes}/${anio}`;
};



const getColorPorEstado = (estado: string) => {
  const colores = new Map<string, string>([
    ['Aceptado', '#d4edda'],      // Verde claro
    ['Rechazado', '#f8d7da'],     // Rojo claro
    ['Pendiente', '#ffcc99'],     // Naranja claro
    ['Anticipada', '#fff3cd'],    // Amarillo claro
    ['Sin solicitudes', 'white'], // Por si acaso
  ]);
  return colores.get(estado) || 'white';
};
  
  const columns = [
    {
      name: <strong><FaUserCheck className="me-2" />Empleado</strong>,
      selector: (row: DTOPermiso) => row.nombreEmpleado,
      sortable: true
    },
    {
      name: <strong><FaRegClock className="me-2" />Fecha Permiso</strong>,
      selector: (row: DTOPermiso) => row.fechaPermiso,
      sortable: true
    },
    { name: 'Motivo', selector: (row: DTOPermiso) => row.motivo },
    { name: 'Estado', selector: (row: DTOPermiso) => row.estado },
    { name: 'Fecha Solicitud', selector: (row: DTOPermiso) => row.fechaSolicitud, sortable: true },
    { name: 'Día Completo', selector: (row: DTOPermiso) => row.esDiaCompleto ? 'Sí' : 'No' },
    { name: 'Hora Inicio', selector: (row: DTOPermiso) => row.horaInicio },
    { name: 'Hora Fin', selector: (row: DTOPermiso) => row.horaFin },
    // { name: 'Observaciones', selector: (row: DTOPermiso) => row.observaciones }, 
{
  name: 'PDF',
  cell: (row: DTOPermiso) => (
    <Button
      variant="info"
      size="sm"
      onClick={() => generarCredencialPermiso(row)}
      disabled={row.estado !== 'Aceptado'}
      title={row.estado !== 'Aceptado' ? 'Solo disponible si el permiso está aceptado' : 'Generar PDF'}
    >
      <i className="fas fa-file-pdf me-1"></i> PDF
    </Button>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true
}

  ];

  return (
    <div>


      
      <Card className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <Button variant="success" onClick={() => setShowModal(true)}>
                <FaPlusCircle className="me-2" />Nuevo Permiso
              </Button>
            </Col>
          </Row>
          <DataTable
            columns={columns}
            data={permisos}
            pagination
            highlightOnHover
            striped
            conditionalRowStyles={[
                {
                  when: (row: DTOPermiso) => true,
                  style: (row: DTOPermiso) => ({
                    backgroundColor: getColorPorEstado(row.estado),
                  }),
                },
              ]}
          />
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Permiso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha del Permiso</Form.Label>
                  <Form.Control
                    type="date"
                    value={nuevoPermiso.fechaPermiso}
                    onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, fechaPermiso: e.target.value })}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre del Empleado</Form.Label>
                  <Form.Control type="text" value={nuevoPermiso.nombreEmpleado} readOnly />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Puesto</Form.Label>
                  <Form.Control type="text" value={nuevoPermiso.puestoEmpleado} readOnly />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Motivo</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={nuevoPermiso.motivo}
                    onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, motivo: e.target.value })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="¿Es día completo?"
                checked={nuevoPermiso.esDiaCompleto}
                onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, esDiaCompleto: e.target.checked })}
              />
            </Form.Group>

            {!nuevoPermiso.esDiaCompleto && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hora de salida</Form.Label>
                    <Form.Control
                      type="time"
                      value={nuevoPermiso.horaInicio}
                      onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, horaInicio: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hora de regreso</Form.Label>
                    <Form.Control
                      type="time"
                      value={nuevoPermiso.horaFin}
                      onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, horaFin: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={insertarPermiso}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      <MsgInformativo
        show={showMsg}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => setShowMsg(false)}
      />
    </div>
  );
};

export default CatPermisosUsuario;
